import type { TelephonySearchValues } from './TelephonySearchFilters'

const URL_KEYS: Record<keyof TelephonySearchValues, string> = {
  q: 'q',
  userId: 'user_id',
  dateFrom: 'date_from',
  dateTo: 'date_to',
}

/** The search and filter values kept in the page's query string. */
export function readTelephonySearch(searchParams: URLSearchParams): TelephonySearchValues {
  return {
    q: searchParams.get(URL_KEYS.q) ?? '',
    userId: searchParams.get(URL_KEYS.userId) ?? '',
    dateFrom: searchParams.get(URL_KEYS.dateFrom) ?? '',
    dateTo: searchParams.get(URL_KEYS.dateTo) ?? '',
  }
}

/** Query-string updates for changed values; a change returns to the first page. */
export function telephonySearchUpdates(
  updates: Partial<TelephonySearchValues>
): Record<string, string | undefined> {
  const urlUpdates: Record<string, string | undefined> = { page: undefined }
  for (const [key, value] of Object.entries(updates) as [keyof TelephonySearchValues, string][]) {
    urlUpdates[URL_KEYS[key]] = value || undefined
  }
  return urlUpdates
}
